import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { DocTypeVersion, ProjectDocReferential } from '../models/models';

@Injectable({
  providedIn: 'root'
})
export class DocTypeVersionService {
  private http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/doc-type-versions`;

  getAllVersions(): Observable<DocTypeVersion[]> {
    return this.http.get<DocTypeVersion[]>(this.apiUrl);
  }

  getLatestVersion(): Observable<DocTypeVersion> {
    return this.http.get<DocTypeVersion>(`${this.apiUrl}/latest`);
  }

  getValidatedReferentials(): Observable<ProjectDocReferential[]> {
    return this.http.get<ProjectDocReferential[]>(`${this.apiUrl}/latest-validated/referentials`);
  }

  createVersion(): Observable<DocTypeVersion> {
    return this.http.post<DocTypeVersion>(this.apiUrl, {});
  }

  duplicateVersion(id: number): Observable<DocTypeVersion> {
    return this.http.post<DocTypeVersion>(`${this.apiUrl}/${id}/duplicate`, {});
  }

  validateVersion(id: number): Observable<DocTypeVersion> {
    return this.http.post<DocTypeVersion>(`${this.apiUrl}/${id}/validate`, {});
  }

  addDocType(versionId: number, docType: ProjectDocReferential): Observable<DocTypeVersion> {
    return this.http.post<DocTypeVersion>(`${this.apiUrl}/${versionId}/doc-types`, docType);
  }

  updateDocType(id: number, docType: ProjectDocReferential): Observable<ProjectDocReferential> {
    return this.http.put<ProjectDocReferential>(`${environment.apiUrl}/projects/doc-referentials/${id}`, docType);
  }

  deleteDocType(id: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/projects/doc-referentials/${id}`);
  }

  canDeleteDocType(id: number): Observable<boolean> {
    return this.http.get<boolean>(`${environment.apiUrl}/projects/doc-referentials/${id}/can-delete`);
  }
}
